import React from 'react';
import {Account} from './context/Accounts';
import {WalletProvider} from './context/WalletContext';
//import Signup from './pages/Signup';
import Login from './pages/Login';
//import ResetPassword from './pages/ResetPassword';
import Status from './components/Status';
import SignupFront from './components/SignupFront';
//import BasicGraph from './components/BasicGraph';
import Models from './pages/Models';
import ThreeD from './pages/Three_D';
import Info from './pages/Info';
import Blocks from './pages/Blocks';
import {ThemeProvider, useTheme} from './context/ThemeContext';

// Images loaded from public folder instead of webpack imports
// import logo from './assets/img/blockhivelogo2.png';
// import waves from './assets/img/Waves.gif'
/* */
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from 'react-router-dom';

import './style/styles.scss';
import Trades from "./pages/Trades";
import Trade from "./pages/Trade";
import NetworkCongestion from "./pages/NetworkCongestion";
import InternalWrapper from "./components/InternalWrapper";
import DashboardGate from "./components/DashboardGate";
import SIE from "./pages/SIE";
import { captureVisitor } from "./utils/sieAttribution";

// Stash the SIE visitor id from the landing URL before the router rewrites it,
// so social-traffic clicks can be attributed at signup.
captureVisitor();


// <img src={process.env.PUBLIC_URL + "Waves.gif"} width={400} height={200} alt="BlockHiveTechnology" />

function AppInner(props) {
  const { theme, toggleTheme } = useTheme();

  return (
    <Account props={props}>
      <InternalWrapper>


        <Router>
          <Switch>
            <Route exact path="/dashboard" render={() => <DashboardGate><Models /></DashboardGate>}/>
            <Route exact path="/models"    render={() => <DashboardGate><Models /></DashboardGate>}/>
            <Route exact path="/trades" component={Trades}/>
            <Route exact path="/ThreeD" component={ThreeD}/>
            <Route exact path="/info" component={Info}/>
            <Route exact path="/blocks" component={Blocks}/>
            <Route exact path="/trade" component={Trade}/>
            <Route exact path="/network-congestion" component={NetworkCongestion}/>
            <Route exact path="/sie" render={() => <DashboardGate><SIE /></DashboardGate>}/>
            <Route exact path="/">
              <Redirect to="/dashboard" />
            </Route>
          </Switch>
        </Router>
      </InternalWrapper>
    </Account>
  );
}

export default (props) => (
  <ThemeProvider>
    <WalletProvider>
      <AppInner {...props} />
    </WalletProvider>
  </ThemeProvider>
);
